import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  apply_job_candidate_action,
  apply_job_mentor_action,
  get_candidate_profile_data_action,
  update_candidate_profile_action,
  get_loggedin_user_meta_data_action,
  get_shared_job_detail_action,
  reject_job_invitation_action,
} from "../../../redux/_actions";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

function useViewJobDetail(props) {
  const [jobDetails, setjobDetails] = useState({});
  const [jobDetailsLoading, setJobDetailsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [jobApplyLoading, setJobApplyLoading] = useState(false);
  const [formSubmitError, setformSubmitError] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [show, setShow] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [fieldsShown, setFieldsShown] = useState({});
  const [formData, setFormData] = useState({});
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);
  const [utmToken, setUtmToken] = useState(null);
  const [utmId, setUtmId] = useState(null);
  const [user, setUser] = useState(null);
  const [userToken, setUserToken] = useState(null);
  const [candidateApplied, setCandidateApplied] = useState(false);
  const [rejectInvitationModal, setRejectInvitationModal] = useState(false);

  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { sharedJobDetailsData } = useSelector(
    (state) => state.get_shared_job_detail_reducer
  );

  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );

  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );

  useEffect(() => {
    getUserToken();
    let url = new URL(window.location.href);
    let user = url.searchParams.get("candidate");
    let utmId = url.searchParams.get("utmid");
    let utmToken = url.searchParams.get("utm_token");

    setUser(user);
    setUtmId(utmId);
    setUtmToken(utmToken);
  }, []);

  //get jobId
  useEffect(() => {
    const id = params?.id;
    if (id) {
      callApi(id);
      getAssignedInterviewkit(id);
    }
    if (userToken) callUserApi();
  }, [userToken]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (sharedJobDetailsData?.data) {
      setjobDetails(sharedJobDetailsData?.data);
    }
  }, [sharedJobDetailsData]);

  useEffect(() => {
    if (loggedInMetaData?.data) {
      setUserDetails(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);

  useEffect(() => {
    if (userProfileData?.data) {
      setUserInfo(userProfileData?.data);
    }
  }, [userProfileData]);

  // useEffect(() => {
  //   let isApplyNow = location?.state && location.state?.isApplyNow;
  //   let jobId = location?.state && location.state?.jobId;

  //   if (userProfileData?.data) {
  //     if (isApplyNow) {
  //       if (!candidateApplied) {
  //         setJobApplyLoading(true);
  //         onSubmitForm(jobId);
  //       }
  //     }
  //   }
  // }, [userProfileData]);

  useEffect(() => {
    let isApplyNow = location?.state && location.state?.isApplyNow;
    if (userProfileData?.data) {
      if (isApplyNow) {
        onViewAssessmentClick();
      }
    }
  }, [userProfileData]);

  useEffect(() => {
    if (sharedJobDetailsData?.data) {
      //set job details
      setjobDetails(sharedJobDetailsData?.data);
    }
  }, [sharedJobDetailsData]);

  const getUserToken = async (id) => {
    const token = await localStorage.getItem("jigsawUser");
    setUserToken(JSON.parse(token));
  };

  const callApi = async (id) => {
    setJobDetailsLoading(true);
    // call job details api
    await dispatch(get_shared_job_detail_action(id));
    if (userToken?.user && userToken.user?.role === "candidate") {
      await dispatch(get_candidate_profile_data_action());
    }
    setJobDetailsLoading(false);
  };

  const callUserApi = async (id) => {
    setLoading(true);
    //call user api
    await dispatch(get_loggedin_user_meta_data_action());
    setLoading(false);
  };

  const getAssignedInterviewkit = async (id) => {
    setLoading(true);
    // await dispatch(get_assigned_interview_kit_job_action(id));
    setLoading(false);
  };

  const onJobApplyClick = async () => {
    setJobApplyLoading(true);

    if (userToken) {
      if (userDetails?.role === "mentor") {
        let res = await dispatch(apply_job_mentor_action(jobDetails?.id));
        if (res?.msg) {
          let errors = formSubmitError;
          errors["msg"] =
            res.msg === "Successfully Created"
              ? "Successfully Applied"
              : res.msg;
          setformSubmitError(errors);
        }
      } else if (userDetails?.role === "candidate") {
        onSubmitForm();
      }

      setJobApplyLoading(false);
    } else {
      if (user && utmId && utmToken) {
        navigate(`/invite-password-reset/${utmId}/${utmToken}?user=${user}`, {
          state: {
            navigateRoute: `/view-job-detail/${jobDetails?.id}`,
            isApplyNow: true,
            jobId: jobDetails?.id,
          },
        });
      } else if (user) {
        navigate("/sign-in", {
          state: {
            navigateRoute: `/view-job-detail/${jobDetails?.id}`,
            isApplyNow: true,
            jobId: jobDetails?.id,
          },
        });
      } else {
        navigate("/sign-in", {
          state: {
            navigateRoute: `/view-job-detail/${jobDetails?.id}`,
            jobId: jobDetails?.id,
          },
        });
      }
    }
  };

  const onJobShareClick = () => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";

    if (jobDetails?.id) {
      const url = isDev
        ? `http://localhost:3000/view-job-detail/${jobDetails?.id}`
        : `${process.env.REACT_APP_DEV_ROOT_URL}/view-job-detail/${jobDetails?.id}`;
      window.navigator.clipboard.writeText(url);

      showSuccessMessage(`Url copied ${url}`);
    }
  };

  const onViewAllJobsClick = () => {
    if (userToken) {
      if (userDetails) {
        if (userDetails?.role === "hiring_manager")
          navigate("/hiring-manager-jobs");
        else navigate("/job-board");
      }
    } else navigate("/dashboard");
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  const onFormDataChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let data = formData;
    data[name] = value;
    setFormData(data);
  };

  const onProfileUpdate = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let data = {};
    data[name] = value;

    await dispatch(update_candidate_profile_action(data));
  };

  const onSubmitForm = async (id) => {
    setFormSubmitLoading(true);

    let jobId = id || jobDetails?.id;

    if (!candidateApplied && jobDetails?.id) {
      setJobApplyLoading(true);
      let res = await dispatch(apply_job_candidate_action(formData, jobId));
      if (res?.msg) {
        let error = {};
        error["msg"] = res.msg;
        setformSubmitError(error);
      }
      if (res?.data) {
        setCandidateApplied(true);
        let data = res?.data;

        if (data?.assigned_assessment_kit) {
          navigate(
            `/assigned-interview-kit?appliedJob=${jobId}&interviewKit=${data?.assigned_assessment_kit}`
          );
        } else navigate("/dashboard");
      }
    }

    setJobApplyLoading(false);
    setFormSubmitLoading(false);
  };

  const onCalendarDashoardClick = async (e) => {
    if (loggedInMetaData) {
      navigate("/calender-dashboard");
    } else {
      showWarningMessage("Login to view calendar dashboard.");
    }
  };
  const onPublicProfileClick = async (e) => {
    if (loggedInMetaData) {
      if (
        loggedInMetaData?.data &&
        loggedInMetaData.data?.role !== "hiring_manager"
      ) {
        if (loggedInMetaData.data?.role === "mentor") {
          navigate(`/mentor-profile/${loggedInMetaData.data?.hash_id}`);
        } else {
          navigate(`/view-candidate-profile/${loggedInMetaData.data?.hash_id}`);
        }
      } else {
        showWarningMessage("Can not view public profile as a Hiring Manager.");
      }
    } else {
      showWarningMessage("Login to view assessment kits.");
    }
  };
  const onAssessmentKitsClick = async (e) => {
    if (loggedInMetaData) {
      if (
        loggedInMetaData?.data &&
        loggedInMetaData.data?.role !== "hiring_manager"
      ) {
        if (loggedInMetaData.data?.role === "mentor") {
          navigate("/mentor-assessment-kits");
        } else {
          navigate(`/assigned-assessment-kits`);
        }
      } else {
        showWarningMessage(
          "Can not view assessment kits as Hiring Manager. View jobs instead."
        );
      }
    } else {
      showWarningMessage("Login to view public profile.");
    }
  };

  const handleRejectInvitationModal = () => {
    setRejectInvitationModal(!rejectInvitationModal);
  };
  const onRejectInvitation = async (id) => {
    await dispatch(
      reject_job_invitation_action(id, { invite_status: "rejected" })
    );
    handleRejectInvitationModal();
  };

  const onViewAssessmentClick = async () => {
    if (userToken) {
     
      if (userDetails?.role === "mentor") {
        showWarningMessage("Unable to view assessment as Mentor.");
      } else if (userDetails?.role === "candidate") {
        navigate(
          `/assigned-interview-kit?appliedJob=${jobDetails?.id}&applicant=${userDetails?.id}&interviewKit=${jobDetails?.assigned_assessment_kit}`
        );
      }
    } else {
      if (user && utmId && utmToken) {
        navigate(`/invite-password-reset/${utmId}/${utmToken}?user=${user}`, {
          state: {
            navigateRoute: `/view-job-detail/${jobDetails?.id}`,
            isApplyNow: true,
            jobId: jobDetails?.id,
          },
        });
      } else if (user) {
        navigate("/sign-in", {
          state: {
            navigateRoute: `/view-job-detail/${jobDetails?.id}`,
            isApplyNow: true,
            jobId: jobDetails?.id,
          },
        });
      } else {
        navigate("/sign-in", {
          state: {
            navigateRoute: `/view-job-detail/${jobDetails?.id}`,
            jobId: jobDetails?.id,
          },
        });
      }
    }
  };

  return {
    jobDetails,
    jobDetailsLoading,
    jobApplyLoading,
    loading,
    formSubmitError,
    userDetails,
    show,
    userInfo,
    fieldsShown,
    formData,
    formSubmitLoading,
    rejectInvitationModal,

    onJobApplyClick,
    onJobShareClick,
    onViewAllJobsClick,
    handleClose,
    onSubmitForm,
    onFormDataChange,
    onProfileUpdate,
    onAssessmentKitsClick,
    onCalendarDashoardClick,
    onPublicProfileClick,
    onRejectInvitation,
    handleRejectInvitationModal,
    onViewAssessmentClick,
  };
}
export default useViewJobDetail;
